import { z } from "zod";
import { VerificationStatus } from "./identityEnum";

// ルートのURLパラメータ検証用（pageを含む）
export const IdentitySearchSchema = z.object({
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(10),
  clientName: z.string().optional(),
  verificationStatus: z.enum(Object.values(VerificationStatus)).optional().default(VerificationStatus.not_submitted),
});

// フォーム用（pageを除外、verificationStatusのdefaultも除外）
export const IdentitySearchFormSchema = z.object({
  limit: z.number().optional(),
  clientName: z.string().optional(),
  verificationStatus: z.enum(Object.values(VerificationStatus)).optional(),
});

